const DiagnosticsReporting = () => (
    <div className="page-content">
        <h1>Reporting</h1>
        <p>Bienvenue sur la page Reporting.</p>
    </div>
);

export default DiagnosticsReporting;